import { render, staticRenderFns } from "./ClientSelectionPage.vue?vue&type=template&id=25e0193e"
import script from "./ClientSelectionPage.vue?vue&type=script&lang=js"
export * from "./ClientSelectionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports